import { defineMessages } from 'react-intl';

export default defineMessages({
    checkingApplication: {
        id: 'checkingEligibility.checkingApplication',
        defaultMessage: "We're checking your application"
    },
    completingApplication: {
        id: 'checkingEligibility.completingApplication',
        defaultMessage: "We're completing your application"
    },
    waitingTime: {
        id: 'checkingEligibility.waitingTime',
        defaultMessage: 'This may take up to 60 seconds'
    },
    almostThere: {
        id: 'additionalInformationRequired.almostThere',
        defaultMessage: `You're almost there!`
    },
    weNeedMoreInfo: {
        id: 'additionalInformationRequired.weNeedMoreInfo',
        defaultMessage: `We just need a little more information and then we'll be ready to make a decision for you.`
    },
    finalStep: {
        id: 'additionalInformationRequired.finalStep',
        defaultMessage: 'Continue to final step'
    }
});
